import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home1'
import Login from '@/views/login/login'
import dingLogin from '@/views/login/dingdinglogin'
import store from '@/vuex/store.js'
import axios from 'axios'

Vue.use(Router)
//动态路由
// scrm模块
const scrm = {
  path: '/scrm',
  component: () => import('@/views/scrm/index.vue'),
  meta: { title: 'scrm' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}
const manageSalesConsultant = {
  path: 'manageSalesConsultant',
  component: () => import('../views/scrm/saleKanban/manageSalesConsultant.vue'),
  meta: { title: '综合看板',keepAlive:true, }
}
// 任务看板
const taskSales = {
  path: 'taskSales',
  component: () => import('@/views/scrm/saleKanban/taskSales.vue'),
  meta: { title: '任务看板' }
}
// 团队看板
const teamSales = {
  path: 'teamSales',
  component: () => import('@/views/scrm/saleKanban/teamSales.vue'),
  meta: { title: '团队看板',keepAlive:true , }
}
// 团队看板
const teamSalesnew = {
  path: 'teamSalesnew',
  component: () => import('@/views/scrm/saleKanban/teamSalesnew.vue'),
  meta: { title: '团队看板',keepAlive:true , }
}

// 客户管理
const customerList = {
  path: 'customerList',
  component: () => import('@/views/scrm/customerManagement/customerList.vue'),
  meta: { title: '我的客户',keepAlive:true , }
}
// 企微客户
const wechatCustomer={
  path: 'wechatCustomer',
  component: () => import('@/views/scrm/customerManagement/wechatCustomer.vue'),
  meta: { title: '企微客户',keepAlive:true , }
}
// 客户黑名单
const customerBlackList={
  path: 'customerBlackList',
  component: () => import('@/views/scrm/customerManagement/customerBlackList.vue'),
  meta: { title: '客户黑名单',keepAlive:true , }
}
const orderList={
  path: 'orderList',
  component: () => import('@/views/scrm/orderManagement/orderList.vue'),
  meta: { title: '我的订单',keepAlive:true , }
}
const refundOrder={
  path: 'refundOrder',
  component: () => import('@/views/scrm/orderManagement/refundOrder.vue'),
  meta: { title: '退款订单',keepAlive:true , }
}
const prizeOrder={
  path: 'prizeOrder',
  component: () => import('@/views/scrm/orderManagement/prizeOrder.vue'),
  meta: { title: '包裹卡兑奖',keepAlive:true , }
}
const invoiceManagementList={
  path: 'invoiceManagementList',
  component: () => import('@/views/scrm/orderManagement/invoiceManagementList.vue'),
  meta: { title: '发票申请',keepAlive:true , }
}
const trafficQuery={
  path: 'trafficQuery',
  component: () => import('@/views/scrm/workManagement/trafficQuery.vue'),
  meta: { title: '话务查询',keepAlive:true , }
}
const messageManagement={
  path: 'messageManagement',
  component: () => import('@/views/scrm/workManagement/messageManagement.vue'),
  meta: { title: '消息管理',keepAlive:true , }
}
const contextOwner={
  path: 'contextOwner',
  component: () => import('@/views/scrm/workManagement/contextOwner.vue'),
  meta: { title: '排班管理',keepAlive:true , }
}
const motivationalLanguage={
  path: 'motivationalLanguage',
  component: () => import('@/views/scrm/workManagement/motivationalLanguage.vue'),
  meta: { title: '员工激励语',keepAlive:true , }
}
const enterpriseWechatList={
  path: 'enterpriseWechatList',
  component: () => import('@/views/scrm/workManagement/enterpriseWechatList.vue'),
  meta: { title: '企微欢迎语',keepAlive:true , }
}
const wecomeMaterial={
  path: 'wecomeMaterial',
  component: () => import('@/views/scrm/workManagement/wecomeMaterial.vue'),
  meta: { title: '企微素材库',keepAlive:true , }
}
const QRcodeManagement={
  path: 'QRcodeManagement',
  component: () => import('@/views/scrm/workManagement/QRcodeManagement.vue'),
  meta: { title: '活码管理',keepAlive:true , }
}
const seaList={
  path: 'seaList',
  component: () => import('@/views/scrm/dataManagement/seaList.vue'),
  meta: { title: '公海数据',keepAlive:true , }
}
const businessCardData={
  path: 'businessCardData',
  component: () => import('@/views/scrm/dataManagement/businessCardData.vue'),
  meta: { title: '名片数据',keepAlive:true , }
}
const issueCustomer={
  path: 'issueCustomer',
  component: () => import('@/views/scrm/dataManagement/issueCustomer.vue'),
  meta: { title: '出单客户',keepAlive:true , }
}
const allocationConfiguration={
  path: 'allocationConfiguration',
  component: () => import('@/views/scrm/dataManagement/allocationConfiguration.vue'),
  meta: { title: '分配配置',keepAlive:true , }
}
const leadCate={
  path: 'leadCate',
  component: () => import('@/views/scrm/dataManagement/leadCate.vue'),
  meta: { title: '线索分类',keepAlive:true , }
}
const forelinkProduct={
  path: 'forelinkProduct',
  component: () => import('@/views/scrm/dataManagement/forelinkProduct.vue'),
  meta: { title: '前链路商品',keepAlive:true , }
}
const clueQuota={
  path: 'clueQuota',
  component: () => import('@/views/scrm/dataManagement/clueQuota.vue'),
  meta: { title: '线索额度',keepAlive:true , }
}

const orderJournal={
  path: 'orderJournal',
  component: () => import('@/views/scrm/journalManagement/orderJournal.vue'),
  meta: { title: '订单日志',keepAlive:true , }
}
const desensitization={
  path: 'desensitization',
  component: () => import('@/views/scrm/journalManagement/desensitization.vue'),
  meta: { title: '脱敏日志',keepAlive:true , }
}
const exportJournal={
  path: 'exportJournal',
  component: () => import('@/views/scrm/journalManagement/exportJournal.vue'),
  meta: { title: '导出日志',keepAlive:true , }
}
const commodityJournal={
  path: 'commodityJournal',
  component: () => import('@/views/scrm/journalManagement/commodityJournal.vue'),
  meta: { title: '商品日志',keepAlive:true , }
}
const sourceList={
  path: 'sourceList',
  component: () => import('@/views/scrm/settingsManagement/sourceList.vue'),
  meta: { title: '订单来源',keepAlive:true , }
}
// scrm模块 end

// ERP模块
const ERP = {
  path: '/ERP',
  component: () => import('@/views/ERP/index.vue'),
  meta: { title: 'ERP' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}
//财务订单
const financialorderList = {
  path:'financialorderList',
  component: () => import('@/views/ERP/orderManagement/financialorderList.vue'),
  meta:{ title: '财务订单',keepAlive:true ,}
}
//库房订单
const warehouseorderList = {
  path:'warehouseorderList',
  component: () => import('@/views/ERP/orderManagement/warehouseorderList.vue'),
  meta:{ title: '库房订单',keepAlive:true ,}
}
const ERPrefundOrder={
  path: 'ERPrefundOrder',
  component: () => import('@/views/scrm/orderManagement/refundOrder.vue'),
  meta: { title: '退款订单',keepAlive:true , }
}
const ERPprizeOrder={
  path: 'ERPprizeOrder',
  component: () => import('@/views/ERP/orderManagement/prizeOrder.vue'),
  meta: { title: '包裹卡兑奖',keepAlive:true , }
}
const commodityList={
  path: 'commodityList',
  component: () => import('../views/ERP/commodityManagement/commodityList.vue'),
  meta: { title: '商品管理',keepAlive:true , }
}
const packageCommodity={
  path: 'packageCommodity',
  component: () => import('../views/ERP/commodityManagement/packageCommodity.vue'),
  meta: { title: '套餐管理',keepAlive:true , }
}
const couponList={
  path: 'couponList',
  component: () => import('../views/ERP/commodityManagement/couponList.vue'),
  meta: { title: '优惠券管理',keepAlive:true , }
}
const brandList={
  path: 'brandList',
  component: () => import('../views/ERP/commodityManagement/brandList.vue'),
  meta: { title: '品牌管理',keepAlive:true , }
}
const storeList={
  path: 'storeList',
  component: () => import('../views/ERP/storeManagement/storeList.vue'),
  meta: { title: '店铺管理',keepAlive:true , }
}
const packageCardList={
  path: 'packageCardList',
  component: () => import('../views/ERP/packageCardList.vue'),
  meta: { title: '包裹卡管理',keepAlive:true , }
}
// ERP模块 end

// 报表模块
const statement = {
  path: '/statement',
  component: () => import('@/views/statement/index.vue'),
  meta: { title: '报表' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}
const dataOverview = {
  path: 'dataOverview',
  component: () => import('../views/statement/dataOverview.vue'),
  meta: { title: '数据总览',keepAlive:true , }
}
const performanceAnalysis = {
  path: 'performanceAnalysis',
  component: () => import('../views/statement/teamAnalyse/performance.vue'),
  meta: { title: '业绩分析',keepAlive:true , }
}
const teamAnalysis = {
  path: 'teamAnalysis',
  component: () => import('../views/statement/teamAnalyse/team.vue'),
  meta: { title: '团队分析',keepAlive:true , }
}
const prizeOverview = {
  path: 'prizeOverview',
  component: () => import('../views/statement/prizeOverview.vue'),
  meta: { title: '兑奖报表',keepAlive:true , }
}
const parcelCardAnalysis = {
  path: 'parcelCardAnalysis',
  component: () => import('../views/statement/activityAnalysis/parcelCard.vue'),
  meta: { title: '包裹卡分析',keepAlive:true , }
}
// 报表模块 end

// 审批模块
const examineApprove = {
  path: '/examineApprove',
  component: () => import('@/views/examineApprove/index.vue'),
  meta: { title: '审批' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}
const refundExamine = {
  path: 'refundExamine',
  // component: () => import('../views/examineApprove/workExamine/refundExamine.vue'),
  component: () => import('@/views/scrm/orderManagement/refundOrder.vue'),
  meta: { title: '退款审批',keepAlive:true , }
}
const invoiceList = {
  path: 'invoiceList',
  component: () => import('@/views/scrm/orderManagement/invoiceManagementList.vue'),
  meta: { title: '发票申请',keepAlive:true , }
}
const companyExamine = {
  path: 'companyExamine',
  component: () => import('@/views/examineApprove/workExamine/companyExamine.vue'),
  meta: { title: '企业审批',keepAlive:true , }
}
const commodityExamine = {
  path: 'commodityExamine',
  component: () => import('@/views/examineApprove/workExamine/commodityExamine.vue'),
  meta: { title: '商品审批',keepAlive:true , }
}
const giftExamine = {
  path: 'giftExamine',
  component: () => import('../views/examineApprove/workExamine/giftExamine.vue'),
  meta: { title: '订单赠品审批',keepAlive:true , }
}
// 审批模块 end

// 系统模块
const system = {
  path: '/system',
  component: () => import('@/views/system/index.vue'),
  meta: { title: '系统' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}
const userList = {
  path: 'userList',
  component: () => import('../views/system/userManagement/userList.vue'),
  meta: { title: '员工管理',keepAlive:true , }
}
const roleList = {
  path: 'roleList',
  component: () => import('../views/system/roleManagement/roleList.vue'),
  meta: { title: '角色管理',keepAlive:true , }
}
const programList = {
  path: 'programList',
  component: () => import('../views/system/programManagement/programList.vue'),
  meta: { title: '栏目管理',keepAlive:true , }
}
const companyList = {
  path: 'companyList',
  component: () => import('../views/system/companyManagement/companyList.vue'),
  meta: { title: '企业管理',keepAlive:true , }
}
const systemConfiguration = {
  path: 'systemConfiguration',
  component: () => import('../views/system/systemConfiguration.vue'),
  meta: { title: '系统配置',keepAlive:true , }
}
// 系统模块end
// 快手模块
const kuaishou = {
  path: '/kuaishou',
  component: () => import('@/views/kuaishou/index.vue'),
  meta: { title: '快手' },
  redirect: '',  // 该配置是若点击选择一级菜单时，默认选中并跳转到该一级菜单下的第一个二级菜单
  children:[],
}


const goodsSale = {
  path:'/saleKanban/goodsSale',
  component: () => import('@/views/saleKanban/goodsSale.vue'),
  meta:{ title: '商品销售',keepAlive:true ,}
}
//趋势报表
const trendReport = {
  path:'/saleKanban/trendReport',
  component: () => import('@/views/saleKanban/trendReport.vue'),
  meta:{ title: '趋势报表',keepAlive:true ,}
}
// 螳螂授权管理
const serviceConfig = {
  path:'/system/serviceConfig',
  component: () => import('@/views/system/serviceConfig.vue'),
  meta:{ title: '授权管理',keepAlive:true ,}
}
const department = {
  path:'/system/department',
  component: () => import('@/views/system/department.vue'),
  meta:{ title: '部门管理',keepAlive:true ,}
}
const undefind = {
  path: '*',
  component: () => import("@/views/404/index"),
  meta:{ title: '404',}
}

const ruleMapping = {
  scrm:scrm,
  manageSalesConsultant:manageSalesConsultant,
  taskSales:taskSales,
  teamSales:teamSales,
  teamSalesnew:teamSalesnew,
  customerList:customerList,
  wechatCustomer:wechatCustomer,
  customerBlackList:customerBlackList,
  orderList:orderList,
  refundOrder:refundOrder,
  prizeOrder:prizeOrder,
  invoiceManagementList:invoiceManagementList,
  trafficQuery:trafficQuery,
  messageManagement:messageManagement,
  contextOwner:contextOwner,
  motivationalLanguage:motivationalLanguage,
  enterpriseWechatList:enterpriseWechatList,
  wecomeMaterial:wecomeMaterial,
  QRcodeManagement:QRcodeManagement,
  seaList:seaList,
  businessCardData:businessCardData,
  issueCustomer:issueCustomer,
  allocationConfiguration:allocationConfiguration,
  leadCate:leadCate,
  forelinkProduct:forelinkProduct,
  clueQuota:clueQuota,
  orderJournal:orderJournal,
  desensitization:desensitization,
  exportJournal:exportJournal,
  commodityJournal:commodityJournal,
  sourceList:sourceList,
  ERP:ERP,
  financialorderList:financialorderList,
  warehouseorderList:warehouseorderList,
  ERPrefundOrder:ERPrefundOrder,
  ERPprizeOrder:ERPprizeOrder,
  commodityList:commodityList,
  packageCommodity:packageCommodity,
  couponList:couponList,
  brandList:brandList,
  storeList:storeList,
  packageCardList:packageCardList,
  statement:statement,
  dataOverview:dataOverview,
  performanceAnalysis:performanceAnalysis,
  teamAnalysis:teamAnalysis,
  parcelCardAnalysis:parcelCardAnalysis,
  prizeOverview:prizeOverview,
  examineApprove:examineApprove,
  refundExamine:refundExamine,
  invoiceList:invoiceList,
  companyExamine:companyExamine,
  commodityExamine:commodityExamine,
  giftExamine:giftExamine,
  system:system,
  userList:userList,
  roleList:roleList,
  programList:programList,
  companyList:companyList,
  systemConfiguration:systemConfiguration,
  kuaishou:kuaishou,
  // trendReport:trendReport,
  // goodsSale:goodsSale,
  // serviceConfig:serviceConfig,
  // department:department,
}
const routes = [
  {
    path: '/',
    component: Home,
    // name: '首页',
    redirect: '/scrm',
    children:[],
    meta:{  title: '首页',}
  },
  {
    path: '/login',
    // name: 'login',
    component: Login,
    meta:{  title: 'login',}
  },

  {
    path: '/dingdinglogin',
    // name: 'dingdinglogin',
    component: dingLogin,
    meta:{  title: 'dingdinglogin',}
  }
]
const router =  new Router({
  mode:'hash',
  // mode:'history',
  routes
})
// 对history模式进行配置
router.history.listen((err, from, to) => {
  if (err.name === 'NavigationDuplicated') {
    return false;
  }
});
//路由前置守卫
var getRouter='';
router.beforeEach((to,from,next) => {
  const token = localStorage.getItem('token');
  // console.log(token);
  // console.log(to.path);
  if(to.path === '/login'||to.path === '/dingdinglogin'){
    next();
  }else{
    if(!token){
      store.dispatch('setToken',null);
      localStorage.removeItem('token');
      store.dispatch('getuserInfo',null);
      localStorage.removeItem('user_info');
      localStorage.removeItem('rightList');
      localStorage.removeItem('settagsList')
      localStorage.removeItem('activePath')
      sessionStorage.removeItem('stateValue');
      sessionStorage.removeItem('searchformbox');
      if(to.path === '/dingdinglogin'){
        next()
      }else{
        next('/login')
      }
      // next('/login')
    }else{
      next();
    }
  }
})
export function initDynamicRoutes(){
  //根据二级权限，对路由规则进行动态添加
  const currentRoutes = router.options.routes;

  currentRoutes[0].children=[];
  const rightList=store.state.rightList||JSON.parse(localStorage.getItem('rightList'));
  // console.log(rightList)

  rightList.forEach(item => {
    const temp =ruleMapping[item.sign];
    // console.log(item,temp);
    // if(temp){
    temp.children=[];
    item.children.forEach(a => {
      if(a.route!=''){
        if(ruleMapping[a.sign]!='undefined'){
          temp.children.push(ruleMapping[a.sign]);
        }
      }else{
        a.children.forEach(b=>{
          if(b.route!=''){
            if(ruleMapping[b.sign]!='undefined'){
              temp.children.push(ruleMapping[b.sign]);
            }
          }
        })
      }
    });
    if(item.children.length){
      // console.log(item.children[0])
    if(item.children[0].route!=''){
      temp.redirect=item.route+'/'+item.children[0].sign;
    }else{
      if(item.children[0].children[0].route!=''){
        temp.redirect=item.route+'/'+item.children[0].children[0].sign;
      }
    }
    }
    // if(temp.children[temp.children.length-1].meta.title!='404'){
    //   temp.children.push(undefind);
    // }
    // console.log(temp);
    currentRoutes[0].children.push(temp);
    // }
  });


  // if(currentRoutes[currentRoutes.length-1].meta.title!='404'){
  //   currentRoutes.push(undefind);
  // }


  // const rightList=store.state.rightList||JSON.parse(localStorage.getItem('rightList'));
  // console.log(rightList)
  // rightList.forEach(item => {
  //   item.children.forEach(m => {
  //     const temp =  ruleMapping[m.sign];
  //     console.log(temp);
  //     currentRoutes[0].children.push(temp);
  //   })
  // })
  // if(currentRoutes[currentRoutes.length-1].name!='404'){
  //   currentRoutes.push(undefind);
  // }
  router.addRoutes(currentRoutes);
  console.log('currentRoutes:',router.getRoutes());
}
export default router




// WEBPACK FOOTER //
// ./src/router/index.js